// Dependencies imports
import React, { useState, useEffect } from "react";
import {
  DataGrid,
  GridToolbar,
  GridToolbarContainer,
} from "@mui/x-data-grid";
import { Constants } from "../../../config/Constants";
// import Modal from "@mui/material/Modal";
// import Fade from "@mui/material/Fade";
import Backdrop from "@mui/material/Backdrop";
import Paper from "@mui/material/Paper";
import Breadcrumb from "../../Breadcrumbs/Breadcrumbs";
import { API } from "aws-amplify";
import Rating from "@mui/material/Rating";
import config from "../../../config/aws-exports";
import Stand from "./objectUsers.module.scss";
import CircularProgress from "@mui/material/CircularProgress";
import { useSelector, useDispatch } from "react-redux";
import { awsSignIn, authData } from "../../../redux/auth/authSlice";


const CourseUsers = () => {
  // const [open, setOpen] = useState(false);
  const [spin, setSpin] = useState(true);
  const [rows, setRows] = useState([]);
  // const [tStandCoursePass, setTStandCoursePass] = useState(false);
  // const [tenants, setTenants] = useState({});
  let userDetails = useSelector(authData);
  //const classes = useStyles();
  const dispatch = useDispatch();

  useEffect(() => {
    getStandAloneCourse(userDetails.tenantdata.tenantname);
    breadcrumb();
    return () => {};
  });

  // function to get Tenants list

  // function to get Tenants list
  async function getStandAloneCourse(val) {
    console.log("userDetails", userDetails);
    setSpin(true);
    const bodyParam = {
      body: {
        org: config.aws_org_id,
        oid: val,
        tid: userDetails.courseID,
        schema: Constants.SCHEMA_NAME,
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    try {
      console.log(bodyParam.body);
      const users = await API.post(
        config.aws_cloud_logic_custom_name,
        Constants.GET_COURSE_ANALYTICS,
        bodyParam
      );
      if (users !== undefined && users !== null) {
        mapData(users.body);
        setSpin(false);
      }
    } catch (error) {
      console.error(error);
      setSpin(false);
    }
  }

  function mapData(value) {
    let trows = [];
    for (let i = 0; i < value.length; i++) {
      let obj = {};
      obj.id = i;
      obj.col1 = value[i].first_name;
      obj.col2 = value[i].last_name;
      obj.col3 = value[i].emailid;
      obj.col4 = value[i].oid;
      obj.col5 =
        value[i].sub_date !== null
          ? value[i].sub_date.substr(0, 10)
          : value[i].sub_date;
      obj.col6 =
        value[i].comp_date !== null
          ? value[i].comp_date.substr(0, 10)
          : value[i].comp_date;
      obj.col7 = value[i].rating;
      trows.push(obj);
    }
    setRows(trows);
  }

  // Custom Toolbard to export and filter for datagrid
  function CustomToolbar() {
    return (
      <GridToolbarContainer
        style={{ display: "flex", justifyContent: "flex-end" }}
      >
        <GridToolbar />
      </GridToolbarContainer>
    );
  }

  const tcolumns = [
    {
      field: "col1",
      headerName: "First Name",
      flex: 1,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "col2",
      headerName: "Last Name",
      flex: 1,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "col3",
      headerName: "Email",
      flex: 1,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "col4",
      headerName: "Organization Name",
      flex: 1,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "col5",
      headerName: "Start Date",
      flex: 1,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "col6",
      headerName: "Completed Date",
      flex: 1,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "col7",
      headerName: "Ratings",
      flex: 1,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => (
        <Rating
          name="read-only"
          value={params.value}
          readOnly
          precision={0.5}
        />
      ),
    },
  ];

  // // function to open select teanant popup
  // const handleOpen = () => {
  //   setOpen(true);
  //   setTStandCoursePass(true);
  // };

  // // function to close select tenant popup
  // const handleClose = () => {
  //   setOpen(false);
  //   setTStandCoursePass(true);
  // };

  function breadcrumb() {
    let sdata = { ...userDetails };
    let temp = [...sdata.breadcrumb];

    temp[2] = {
      name: userDetails.topicName,
      path: "/tenants/viewTenant/courseusers",
    };

    sdata.breadcrumb = temp;

    dispatch(awsSignIn(sdata));
  }

  return (
    <div className={Stand.main}>
      <Breadcrumb Bindex={2} />

      <Backdrop className={Stand.backdrop} open={spin}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <Paper style={{ marginTop: "20px" }}>
        <div
          style={{
            height: 350,
            width: "100%",
            overflowY: "auto",
          }}
          className={Stand.root}
        >
          <DataGrid
            rows={rows}
            columns={tcolumns}
            className={Stand.MuiDataGridRoot}
            slots={{
              toolbar: CustomToolbar,
            }}
          />
        </div>
      </Paper>
    </div>
  );
};

export default CourseUsers;
